<template>
<div class="pa-4">
  <v-data-table
    :headers="headers"
    :items="items"
    :single-expand="true"
    item-key="id"
    :loading="loading"
    show-expand
    class="modern-table border rounded overflow-hidden elevation-0"
    hide-default-footer
  >
    <template v-slot:no-data>
      <v-alert type="info" text dense icon="fas fa-info-circle" class="ma-4">
        No existen órdenes de compra vinculadas.
      </v-alert>
    </template>

    <template v-slot:item.id="{ item }">
      <span class="font-weight-bold">#{{ item.id }}</span>
    </template>

    <template v-slot:item.date="{ item }">
      <div class="body-2">{{ item.created_at | moment("DD/MM/YYYY") }}</div>
    </template>
    
    <template v-slot:item.provider_name="{ item }">
      <div class="body-2 font-weight-medium text-truncate" style="max-width: 200px;">
        {{ item.provider_name }}
      </div>
    </template>

    <template v-slot:item.total="{ item }">
      <div class="text-right font-weight-bold">
        {{ totalOrder(item) | moneda }}
      </div>
    </template>

    <template v-slot:item.estatus="{ item }">
      <div class="text-right">
        <v-chip 
          small 
          label 
          :color="getStatusColor(item)" 
          class="font-weight-bold px-3"
        >
          {{ getStatusName(item) }}
        </v-chip>
      </div>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="expanded-row-bg pa-6">
        <v-card outlined class="elevation-2 overflow-hidden">
          <detailed-purchase-order :purchaseOrder="item" :inSet="true" />
        </v-card>
      </td>
    </template>
  </v-data-table>
</div>
</template>

<script>
import { fetchPurchase } from "@/api/stocks";
import DetailedPurchaseOrder from "@/components/stocks/DetailedPurchaseOrder";

export default {
  name: "PurchaseOrders",
  components: {
    DetailedPurchaseOrder,
  },
  props: ["workorder"],
  data() {
    return {
      headers: [
        { text: "Número", value: "id", width: '100' },
        { text: "Fecha", value: "date", width: '120' },
        { text: "Proveedor", value: "provider_name", align: "start" },
        { text: "Referencia", value: "title", align: "end" },
        { text: "Total", value: "total", align: "end", width: '120' },
        { text: "Estatus", value: "estatus", align: "end", width: '150' },
        { text: "", value: "data-table-expand", align: "end", width: '50' },
      ],
      estatuses: [
        { value: 1, text: "Ingresada", color: "info" },
        { value: 2, text: "Aprobada", color: "success" },
        { value: 4, text: "Recepcionada", color: "grey" },
        { value: 3, text: "Anulada", color: "error" },
      ],
      loading: false,
      items: [],
    };
  },
  methods: {
    getPurchaseOrders() {
      this.loading = true;
      const query = `work_order=${this.workorder.id}`;
      fetchPurchase(query)
        .then((response) => {
          this.items = response.results;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    totalOrder(item) {
      const total = item.details.reduce((acc, val) => acc + parseFloat(val.qty) * parseFloat(val.price), 0)
      return total - total * parseFloat(item.discount) / 100
    },
    getStatusName(item) {
      const status = this.estatuses.find(i => i.value == item.estatus)
      return status ? status.text : 'Desconocido'
    },
    getStatusColor(item) {
      const status = this.estatuses.find(i => i.value == item.estatus)
      return status ? status.color : 'grey'
    },
  },
  created() {
    this.getPurchaseOrders();
  }
};
</script>

<style scoped>
.modern-table.border {
  border: 1px solid rgba(0,0,0,0.08) !important;
}
.expanded-row-bg {
  background-color: #f1f3f4 !important;
}
</style>
